import React, { memo } from "react";
import { useDisclosure } from '@chakra-ui/react'
import { useEditEnglishMenuImage } from "../../../hooks/menu/useEditEnglishMenuImage";
import { MenuEditModalLayout } from "./MenuEditModalLayout";

type MenuEditModalProps = {
  id: string;
  mutateKey: string;
}
export const EnglishMenuEditModal: React.FC<MenuEditModalProps> = memo(({id, mutateKey}) => {
  const { isOpen, onOpen, onClose } = useDisclosure()
  const onSubmit = useEditEnglishMenuImage(id, mutateKey, onClose)
  return (
    <MenuEditModalLayout
      isOpen={isOpen}
      onOpen={onOpen}
      onClose={onClose}
      onSubmit={onSubmit}
    />
  );
});